import React from 'react';

import { makeStyles, Theme } from '@material-ui/core';
import { Translate, TranslateFunction } from 'react-localize-redux';

import { Box } from '@fd/ui/atoms';
import { FormSection } from '@fd/ui/molecules';

import AssignStoresVisibility from '../../../components/AssignStoresVisibility';

const useStyles = makeStyles((theme: Theme) => ({
  androidStoreContainer: {
    marginBottom: theme.spacing(4),
    position: 'relative',
    zIndex: 10,
  },
  box: {
    marginTop: theme.spacing(3),
    paddingBottom: theme.spacing(5),
  },
}));

export type GeneralSettingsProps = {
  appId: string;
  canEdit: boolean;
  translate: TranslateFunction;
};

export const GeneralSettings = (props: GeneralSettingsProps) => {
  const { appId, canEdit, translate } = props;
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <FormSection sectionTitle={translate('Stores_visibility') as string} showDivider={false}>
        {/* TODO: replace with a combined filter when an api is created to support this */}
        <div className={classes.androidStoreContainer}>
          <AssignStoresVisibility
            description={
              <Translate
                id="Change_the_visibility_of_the_stores_on_{appType}_app"
                data={{ AppType: 'Android' }}
              />
            }
            appId={appId}
            appType="Android"
            channelId={2}
            isDisabled={!canEdit}
            translate={translate}
          />
        </div>
        <AssignStoresVisibility
          description={
            <Translate
              id="Change_the_visibility_of_the_stores_on_{appType}_app"
              data={{ AppType: 'iOS' }}
            />
          }
          appId={appId}
          appType="iOS"
          channelId={1}
          isDisabled={!canEdit}
          translate={translate}
        />
      </FormSection>
    </Box>
  );
};
